var map = {
	"./en-SG": 315588,
	"./en-SG.js": 315588,
	"./en-au": 722072,
	"./en-au.js": 722072,
	"./en-ca": 796050,
	"./en-ca.js": 796050,
	"./en-gb": 88203,
	"./en-gb.js": 88203,
	"./en-ie": 277872,
	"./en-ie.js": 277872,
	"./en-il": 822767,
	"./en-il.js": 822767,
	"./en-nz": 365362,
	"./en-nz.js": 365362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669186;